












import Vue from "vue";
export default Vue.extend({
  props: {
    profile: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      document: [
        {
          text: "Contactos",
          icon: "fas fa-address-book",
          to: { name: `contact${this.profile}` },
        },
      ],
    };
  },
});
